<template>

    <div class="row">

        <b-modal size="lg"
                 button-size="sm"
                 id="invoicePositionDialog" centered title="Neue Position"
                 @ok="handleOk"
                 @shown="dialogReset"
                 cancel-title="Abbrechen"
                 ref="invoicePositionDialogRef"
        >
            <div class="container">

                <div class="form-row align-items-end">
                    <div class="form-group col-12">
                        <label for="invoiceWork">Leistung:</label>

                        <b-form-input id="invoiceWork"
                                      autocomplete="off"
                                      type="text"
                                      v-validate="'required'"
                                      name="invoiceWork"
                                      v-model.trim="work"
                                      ref="invoiceWorkRef"
                                      :state="checkState('invoiceWork')"
                        ></b-form-input>
                        <span v-show="errors.has('invoiceWork')" class="error-message">Bitte eine Leistung definieren</span>
                    </div>
                </div>

                <div class="form-row align-items-end mb-5">

                    <div class="form-group col-md-6">
                        <label for="invoiceFrom">Von</label>
                        <div><datepicker
                                input-class="form-control"
                                format="dd.MM.yyyy"
                                :language="languages.de"
                                v-model="dateFrom"
                                v-validate="'required'"
                                name="invoiceDateFrom"
                                :state="checkState('invoiceDateFrom')"
                                >

                        </datepicker></div>
                        <span v-show="errors.has('invoiceDateFrom')" class="error-message">Du musst ein Datum eingeben</span>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="invoiceTo">Bis</label>
                        <div><datepicker
                                input-class="form-control"
                                format="dd.MM.yyyy"
                                :language="languages.de"
                                v-model="dateTo"
                                v-validate="'required'"
                                name="invoiceDateTo"
                                :state="checkState('invoiceDateTo')"
                                >
                        </datepicker></div>
                        <span v-show="errors.has('invoiceDateTo')" class="error-message">Du musst ein Datum eingeben</span>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="invoiceWorkAmount">Menge</label>
                        <b-form-input id="invoiceWorkAmount"
                                      autocomplete="off"
                                      :state="checkState('invoiceWorkAmount')"
                                      type="text"
                                      v-validate="'required|numeric'"
                                      name="invoiceWorkAmount"
                                      v-model.trim="amount"
                                      class="text-right"
                        ></b-form-input>
                        <span v-show="errors.has('invoiceWorkAmount')" class="error-message">Du musst die Menge eingeben</span>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="invoiceWorkPrice">Betrag</label>
                        <b-form-input id="invoiceWorkPrice"
                                      autocomplete="off"
                                      v-bind:state="checkState('invoiceWorkPrice')"
                                      type="text"
                                      v-validate="'required|numeric'"
                                      name="invoiceWorkPrice"
                                      v-model.trim="price"
                                      class="text-right"
                        ></b-form-input>
                        <span v-show="errors.has('invoiceWorkPrice')" class="error-message">Du musst den Preis eingeben</span>
                    </div>
                </div>

            </div>
        </b-modal>
    </div>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import * as lang from "vuejs-datepicker/src/locale";

    export default {

        name: 'InvoicePositionDialog',
        components: {Datepicker},

        props: {
            project: {
                type: Object
            }
        },

        data: function() {
            return {

                title: 'Rechnungsposition',
                work: null,
                dateFrom: '',
                dateTo: '',
                amount: 1,
                price: null,
                languages: lang
            }
        },

        methods: {

            checkState(fieldName) {

                if (!this.errors.has(fieldName)) {
                    return null;
                }

                return false;
            },

            dialogReset() {
                this.work = null;
                this.dateFrom = '';
                this.dateTo = '';
                this.amount = 1;
                this.price = null;
                this.$validator.reset();
                this.$refs.invoiceWorkRef.focus();
            },

            handleOk(e) {

                e.preventDefault();

                this.$validator.validateAll().then(valid => {

                    if (valid) {

                        this.emitSave({work: this.work, dateFrom: this.dateFrom, dateTo: this.dateTo, amount: this.amount, price: this.price});
                        this.$refs.invoicePositionDialogRef.hide();
                    }
                });
            },

            openDialog() {
                this.$refs.invoicePositionDialogRef.show();
            },

            emitSave(invoicePosition) {

                this.$emit('save', invoicePosition);
            }
        }
    }
</script>

<style scoped>

</style>